import React from 'react';
import css from "./GroupSessionInformation.css";
import Icon from 'SF/MaterialIcon';
import KioskImage from "./KioskImage";
import {getPhotoURL} from "../utils/images";
import PropTypes from 'prop-types'
import moment from "moment";
import {getDateFormat} from "../utils/time";

function GroupSessionInformation(props) {
  const getSessionTime = (groupSession) => {
    const endDate = moment(groupSession.endDate);
    const startDate = moment(groupSession.startDate);

    const hourFormat = getDateFormat('timeDisplayFormat');
    let startDateFormat = hourFormat;

    // If both startDate and endDate are on the same meridiem (both are a.m. or both are p.m.), then the start date
    // should not show a.m. or p.m. The format 'a' returns am or pm
    if (startDate.format('a') === endDate.format('a')) {
      if (hourFormat.indexOf('a') > -1) {
        startDateFormat = hourFormat.replace('a', '').trim();
      }
    }

    return `${startDate.format(startDateFormat)}-${endDate.format(hourFormat)}`
  };

  const getSpotsAvailableText = (groupSession) => {
    const groupSpotsAvailable = groupSession.groupSpotsAvailable;
    if (groupSpotsAvailable > 0) {
      const spotText = groupSpotsAvailable > 1 ? 'spots' : 'spot';
      return `(${groupSpotsAvailable} ${spotText} left)`
    }
  };

  const getCourseContext = (groupSession) => {
    const courseRestrictions = groupSession.courseRestrictions || [];
    if (courseRestrictions.length && groupSession.supplementalInstruction) {
      return courseRestrictions[0].name;
    } else {
      return null;
    }
  };

  const { groupSession } = props;
  return (
    <div className={css['information']} id={props.labelId}>
      <div>
        <div className={css['title']}>
          {groupSession.title} {getSpotsAvailableText(groupSession)}
          <Icon icon='group' aria-hidden='true'/>
          <br/>
          {getSessionTime(groupSession)}
        </div>
        <div className={css['session-information']}>
            <span className={css["img"]}>
              <KioskImage imageUrl={getPhotoURL(groupSession.ownerUid, true)} size={'S'}/>
            </span>
          <div className={css['card']}>
            <div className={css['owner-name']}>{groupSession.ownerPartyName}</div>
            <div className={'course-context'}>{getCourseContext(groupSession)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

GroupSessionInformation.propTypes = {
  groupSession: PropTypes.object.isRequired,
  labelId: PropTypes.string
};

export default GroupSessionInformation;
